/**
 * bh-menu-scroll-lock.js
 *
 * Desktop nav scroll-lock (client request): while a top-level dropdown or
 * mega-menu is open (hovered) on a pointer device, block page scrolling so the
 * open panel stays put under the cursor instead of the page sliding behind it.
 *
 * How it stays correct & light:
 *  - Each panel/.sub-menu is a DOM *descendant* of its <li.menu-item-has-children>,
 *    so mouseenter/mouseleave on that <li> tracks "hovering the item OR anywhere
 *    inside the open panel" — mirroring the CSS :hover that opens it.
 *  - Gated on (hover: hover) and (pointer: fine) so it only affects mouse/trackpad
 *    desktops. On touch/mobile the desktop menu is display:none and can't be
 *    hovered, so this no-ops there regardless.
 *  - The non-passive wheel blocker is attached ONLY while a menu is open and
 *    removed as soon as it closes, so normal page scrolling is never burdened by
 *    a non-passive listener.
 */
(function () {
  if (window.__bhMenuScrollLock) return; // guard against a duplicated header
  window.__bhMenuScrollLock = true;

  var items = document.querySelectorAll('.thb-full-menu > .menu-item-has-children');
  if (!items.length) return;

  var pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var open = 0; // count of top-level dropdown items currently hovered

  function block(e) {
    e.preventDefault();
  }
  function lock() {
    // passive:false so preventDefault() actually stops the scroll gesture.
    window.addEventListener('wheel', block, { passive: false });
  }
  function unlock() {
    window.removeEventListener('wheel', block);
  }

  items.forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      if (!pointer.matches) return;
      open += 1;
      if (open === 1) lock();
    });
    li.addEventListener('mouseleave', function () {
      if (open === 0) return;
      open -= 1;
      if (open === 0) unlock();
    });
  });

  // Safety valve: clear any residual lock if the pointer capability changes.
  var reset = function () { open = 0; unlock(); };
  if (pointer.addEventListener) pointer.addEventListener('change', reset);
  else if (pointer.addListener) pointer.addListener(reset);
})();
